import { graphql } from "../gql";
import { useQuery } from "@apollo/client";

const GetUserGroupAvailableDaysQuery = graphql(`
  query getUserGroupAvailableDays {
    getUserGroupAvailableDays {
      availableWeekDays
    }
  }
`);
export function useGetUserGroupAvailableDays() {
  const { data, loading } = useQuery(GetUserGroupAvailableDaysQuery);

  return {
    availableDays: data?.getUserGroupAvailableDays?.availableWeekDays ?? [],
    loading,
  };
}
